import axios from "axios";
import React, { useState } from "react";
import { Snackbar, Alert, Button } from "@mui/material";

const InputField = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  readOnly,
}) => (
  <div className="my-2">
    <label className="text-xs text-gray-600 my-1 block">{label}</label>
    <input
      type={type}
      value={value}
      readOnly={readOnly}
      onChange={onChange}
      placeholder={placeholder}
      className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
    />
  </div>
);

const SelectField = ({ label, value, onChange, children }) => (
  <div className="my-2">
    <label className="text-xs text-gray-600 my-1 block">{label}</label>
    <select
      value={value}
      onChange={onChange}
      className="w-full px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
    >
      {children}
    </select>
  </div>
);

const DeliverySchedule = () => {
  const [formData, setFormData] = useState({
    group: "",
    description: "",
  });

  const typeList = [];

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

      const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });

    const handleClose = () => {
      setSnackbar((prev) => ({ ...prev, open: false }));
    };

  const postTaskData = async () => {


    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    const payload = [
      {
        CmpCode: companyCode,
        mode: "ENTRY",
        task_id: "1001",
        deptno: department,
        task_doc: "30002",
        task_date: "2026-01-12T10:30:00",
        timeslot: "10:00-12:00",
        creator: "ADMIN",
        created_date: "2026-01-12T09:45:00",
        tasktype: "DELIVERY",
        sku: "5",
        assignee: "DRIVER01",
        taskmode: "e-bike",
        sender: "MAIN",
        receiver: "XYZ Customer",
        pickfrom: "MAIN",
        deliverto: "Riyadh Outlet",
        pickGPS: "25.2048,55.2708",
        deliverGPS: "24.7136,46.6753",
        primarydoc: "7788",
        pdocdate: "2026-01-11T00:00:00",
        custref: "8899",
        suppref: "",
        primarydoc2: "3333",
        pdocdate2: "2026-01-11T00:00:00",
        cbm: "2.5",
        weight: "150",
        assignto: "DRIVER1",
        notes: "Handle with care",
        paymentinstruction: "COD",
        piamount: "2500",
        attachment: "",
        status: "",
        packageno: "",
        packagetype: "",
        packagecount: "0",
        packagecondition: "",
        receivedfrom: "",
        handedto: "",
        deliveryto: "",
      },
    ];

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");

    try {
      const response = await axios.post(
        `${apiPaths[0]?.API_CONFIG}/api/CRMLogisticTask`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Success:", response.data);

      setSnackbar({
        open: true,
        message: "Task posted successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error(
        "Error posting task:",
        error.response?.data || error.message
      );
      setSnackbar({
        open: true,
        message:
          error.response?.data?.message ||
          "Failed to post task. Please try again.",
        severity: "error",
      });
    }
  };

  return (
    <div className="p-6 min-h-screen space-y-4">
      {/* Header */}
      <div className="bg-white border rounded p-4">
        <div className="flex justify-between items-end gap-6">
          <div className="w-80">
            <SelectField
              label="Type"
              value={formData.group}
              onChange={(e) => handleChange("group", e.target.value)}
            >
              <option value="">Pick from List</option>
              {typeList.map((type, index) => (
                <option key={index} value={type.DESCRIPTION}>
                  {type.DESCRIPTION}
                </option>
              ))}
            </SelectField>
          </div>

          {/* <div className="flex gap-3"> */}
          <InputField label="Task Request #" value="1002" readOnly />
          <InputField label="User" value="ADMIN" readOnly />
          <InputField label="Branch" value="Kera" readOnly />
          {/* </div> */}
        </div>
      </div>

      {/* Party Details */}
      <div className="grid grid-cols-2 gap-6 ">
        {/* Left Party */}
        <div className="bg-white border  p-4 rounded">
          <InputField label="From" placeholder="Party Name" />
          <div className="grid grid-cols-2 gap-3">
            <InputField label="Primary Doc#" placeholder="Doc No" />
            <InputField label="Date & Time" type="datetime-local" />
          </div>
          <InputField label="Customer Ref#" placeholder="Reference" />
        </div>

        {/* Right Party */}

        <div className="bg-white border p-4 rounded">
          <InputField label="To" placeholder="Party Name" />
          <div className="grid grid-cols-2 gap-3">
            <InputField label="Primary Doc#" placeholder="Doc No" />
            <InputField label="Date & Time" type="datetime-local" />
          </div>
          <InputField label="Supplier Ref#" placeholder="Reference" />
        </div>
      </div>

      {/* Pickup & Delivery */}
      <div className="bg-white border rounded p-4">
        <div className="flex gap-6 mb-4">
          {["On foot", "eBike", "Motorcycle", "Car", "Van", "Pickup Truck"].map(
            (v) => (
              <label key={v} className="flex items-center gap-2 text-sm">
                <input type="radio" name="vehicle" />
                {v}
              </label>
            )
          )}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <InputField label="Pick From" placeholder="Pickup Location" />
          <InputField label="Deliver To" placeholder="Delivery Location" />
        </div>
      </div>

      {/* Schedule */}
      <div className="bg-white border rounded p-4 grid grid-cols-3 gap-6">
        <InputField label="Delivery Date" type="date" />

        <div className="space-y-2">
          <label className="text-xs text-gray-600">Time Slot</label>
          {[
            "07:30 AM - 09:30 AM",
            "09:30 AM - 11:30 AM",
            "01:30 PM - 06:00 PM",
            "Special Delivery Case",
          ].map((slot) => (
            <label key={slot} className="flex items-center gap-2 text-sm">
              <input type="radio" name="slot" />
              {slot}
            </label>
          ))}
        </div>

        <div>
          <InputField label="CBM" placeholder="CBM" />
          <InputField label="Weight" placeholder="Weight" />
          <SelectField label="Assigned To">
            <option>Open</option>
            <option>Driver 1</option>
          </SelectField>
          <InputField
            label="Notes"
            placeholder=" Type Notes (Visible to Driver)"
          />
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center">
        <button className="border px-4 py-2 text-sm rounded">
          Attach Documents
        </button>

        <div className="flex gap-3">
          <button className="border px-4 py-2 text-sm rounded">
            Save for Later
          </button>
          <button className="border px-4 py-2 text-sm rounded text-red-500">
            Delete Request
          </button>
          <button
            onClick={postTaskData}
            className="bg-teal-600 text-white px-6 py-2 rounded"
          >
            Send Request
          </button>
        </div>
      </div>

    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="filled"
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
    </div>
  );
};

export default DeliverySchedule;
